import Vue from 'vue';
import { Commit } from 'vuex';
import { LimboController } from '@/interfaces/controllers';

interface LimboControllerState {
	limboControllers: {
		[id: number]: LimboController;
	};
}

export default {
	namespaced: true,
	state: {
		limboControllers: {},
	} as LimboControllerState,
	getters: {
		getLimboControllers: (state: LimboControllerState): LimboController[] => {
			return Object.values(state.limboControllers);
		},

		getLimboController:
			(state: LimboControllerState) =>
			(id: number): LimboController | undefined => {
				return state.limboControllers[id];
			},
	},
	mutations: {
		SET_LIMBO_CONTROLLERS(
			state: LimboControllerState,
			{ limboControllers, gatewayId }: { limboControllers: LimboController[]; gatewayId: number }
		): void {
			limboControllers.forEach((limboController: LimboController) => {
				limboController.gateway_id = gatewayId;
				Vue.set(state.limboControllers, limboController.id, limboController);
			});
		},

		CLEAN_CERTAIN_LIMBO_CONTROLLER(state: LimboControllerState, id: number): void {
			Vue.delete(state.limboControllers, id);
		},

		CLEAN_LIMBO_CONTROLLERS(state: LimboControllerState): void {
			state.limboControllers = {};
		},
	},
	actions: {
		async fetchLimboControllers(
			{ commit }: { commit: Commit },
			{ gatewayId }: { gatewayId: number }
		): Promise<void> {
			const response = await Vue.axios.get(
				`${process.env.VUE_APP_API_URL}/controllers/limbo/${gatewayId}`
			);

			if (response && response.status === 200) {
				commit('SET_LIMBO_CONTROLLERS', {
					limboControllers: response.data.data,
					gatewayId: gatewayId,
				});
			}
		},

		async deleteLimboController(
			{ commit }: { commit: Commit },
			{ id, gateway_id, guid }: { id: number; gateway_id: number; guid: string }
		): Promise<void> {
			const response = await Vue.axios.delete(
				`${process.env.VUE_APP_API_URL}/controllers/limbo/${gateway_id}/${guid}`
			);
			if (response && response.status === 200) {
				commit('CLEAN_CERTAIN_LIMBO_CONTROLLER', id);
			}
		},

		async commissionLimboControllers(
			{ commit }: { commit: Commit },
			{ guids, limboIds, gatewayId }: { guids: string[]; limboIds: number[]; gatewayId: number }
		): Promise<void> {
			const response = await Vue.axios.post(
				`${process.env.VUE_APP_API_URL}/controllers/limbo/${gatewayId}`,
				{ guids: guids }
			);

			if (response && response.status === 200) {
				limboIds.forEach((id) => commit('CLEAN_CERTAIN_LIMBO_CONTROLLER', id));
				commit('controllers/controllers/ADD_CONTROLLERS', response.data.data, { root: true });
			}
		},

		cleanLimboControllers({ commit }: { commit: Commit }): void {
			commit('CLEAN_LIMBO_CONTROLLERS');
		},
	},
};
